/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyColumnKind } from './DutyColumnKind';
import {
    DutyColumnKindFromJSON,
    DutyColumnKindFromJSONTyped,
    DutyColumnKindToJSON,
    DutyColumnKindToJSONTyped,
} from './DutyColumnKind';

/**
 * 
 * @export
 * @interface DutyScheduleColumnResponse
 */
export interface DutyScheduleColumnResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleColumnResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleColumnResponse
     */
    sortOrder: number;
    /**
     * 
     * @type {DutyColumnKind}
     * @memberof DutyScheduleColumnResponse
     */
    kind: DutyColumnKind;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleColumnResponse
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleColumnResponse
     */
    courtId: string | null;
}



/**
 * Check if a given object implements the DutyScheduleColumnResponse interface.
 */
export function instanceOfDutyScheduleColumnResponse(value: object): value is DutyScheduleColumnResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('courtId' in value) || value['courtId'] === undefined) return false;
    return true;
}

export function DutyScheduleColumnResponseFromJSON(json: any): DutyScheduleColumnResponse {
    return DutyScheduleColumnResponseFromJSONTyped(json, false);
}

export function DutyScheduleColumnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleColumnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sortOrder': json['sortOrder'],
        'kind': DutyColumnKindFromJSON(json['kind']),
        'label': json['label'],
        'courtId': json['courtId'],
    };
}

export function DutyScheduleColumnResponseToJSON(json: any): DutyScheduleColumnResponse {
    return DutyScheduleColumnResponseToJSONTyped(json, false);
}

export function DutyScheduleColumnResponseToJSONTyped(value?: DutyScheduleColumnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sortOrder': value['sortOrder'],
        'kind': DutyColumnKindToJSON(value['kind']),
        'label': value['label'],
        'courtId': value['courtId'],
    };
}

